import type MessageBag from '@/infrastructure/support/MessageBag.ts';

export default class ApiError extends Error {
  readonly code: number;
  readonly messageBag: MessageBag;

  constructor(code: number, messageBag: MessageBag) {
    const message = messageBag?.all()?.[0] ?? `Api error: ${code}`;

    super(message);

    this.code = code;
    this.messageBag = messageBag;
  }
}
